import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import { loadAllPaymentPlans } from "../../actions/dataLoad";
import LoadingSessionBooked from "../../components/Utilities/Loading/LoadingSessionBooked";
import AOS from "aos";
import "./index.css";
import "aos/dist/aos.css";
import Alert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import { useUserInfoSelector, useUserTokenSelector } from "store/reducers";
import { useDispatch } from "react-redux";
import { startLoading, stopLoading } from "store/actions";
import BookNowButton from "../../assets/svg_icons/book_now_button.svg";
import { IoIosArrowBack } from "react-icons/io";
import { bookSession } from "../../actions/bookSlot";
import { createMeeting } from "../../actions/meetings";
AOS.init();

export const PaymentPlan = ({
  routeProps,
  categoryId,
  plans,
  walletSessionBalance,
  payAndBookEvent,
  errorPayment,
  setErrorPayment,
  loading,
  setShowPayment,
  currency,
  handleLogout,
}) => {
  const history = useHistory();
  const userToken = useUserTokenSelector();
  const userInfo = useUserInfoSelector();
  const [paymentPlans, setPaymentPlans] = useState([]);
  const [walletBalance, setWalletBalance] = useState(0);
  const [categoryid, setCategoryid] = useState();
  const [paymentCurrency, setPaymentCurrency] = useState();
  const [errorpayment, setErrorpayment] = useState(false);
  const [selectedSubscription, setSelectedSubscription] = useState("Bi-monthly Subscription");
  const [open, setOpen] = useState(false);
  const [error, setError] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);
  const [walletAutoBookingTriggered, setWalletAutoBookingTriggered] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const getPlanFeatures = (plan) => (Array.isArray(plan?.planFeatures) ? plan.planFeatures : []);
  const marketplaceTherapistId =
    routeProps?.therapistId || location.state?.marketplaceTherapist?._id || location.state?.therapistId || "";
  const marketplaceTherapist = location.state?.marketplaceTherapist;
  const selectedDate = location.state?.selectedDate;
  const selectedTime = location.state?.selectedTime;
  const isMarketplaceBookingFlow =
    Boolean(marketplaceTherapistId) &&
    Boolean(selectedDate) &&
    selectedTime?.hours !== undefined &&
    selectedTime?.minutes !== undefined;
  const progressStepCount = isMarketplaceBookingFlow ? 2 : 3;
  const completedStepCount = isMarketplaceBookingFlow ? 1 : 2;
  const progressFillWidth = `${(completedStepCount / progressStepCount) * 100}%`;

  const loadScript = (src) =>
    new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });

  const buildLocalDateTimeString = () => {
    if (!selectedDate || selectedTime?.hours === undefined || selectedTime?.minutes === undefined) {
      return null;
    }

    const slotDateTime = new Date(
      `${selectedDate.replace(/-/g, "/")} ${String(selectedTime.hours).padStart(2, "0")}:${String(selectedTime.minutes).padStart(
        2,
        "0",
      )}:00`,
    );

    return Number.isNaN(slotDateTime.getTime()) ? null : slotDateTime.toString();
  };

  const createDyteMeeting = async () => {
    return createMeeting({
      title: "Good Lives",
      preferred_region: "ap-south-1",
      record_on_start: false,
      live_stream_on_start: false,
    });
  };

  const redirectToMyBookings = (state = {}) => {
    history.push({
      pathname: "/dashboard/my-bookings",
      state,
    });
  };

  const redirectAfterMarketplaceBooking = (state = {}) => {
    history.push({
      pathname: "/dashboard/my-therapist",
      state,
    });
  };

  const buildBookingRequestData = async (selectedPlan, overrides = {}) => {
    if (!marketplaceTherapistId || !selectedDate || selectedTime?.hours === undefined || selectedTime?.minutes === undefined) {
      throw new Error("Missing booking details. Please select the slot again.");
    }

    const GMTSlotDateTime = buildLocalDateTimeString();

    if (!GMTSlotDateTime) {
      throw new Error("Invalid booking date or time.");
    }

    const meetid = overrides.meetid || (await createDyteMeeting());
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const primaryProblem =
      marketplaceTherapist?.specialities?.[0]?.problemID ||
      "";

    return {
      therapists: [marketplaceTherapistId],
      date: selectedDate,
      time: `${selectedTime.hours} : ${selectedTime.minutes}`,
      month: new Date(selectedDate).getMonth(),
      GMTSlotDateTime,
      userTimeZone,
      problemDescription: marketplaceTherapist?.designation || "Marketplace booking",
      planName: selectedPlan.planName,
      mobile: userInfo?.mobileNo || "",
      planId: selectedPlan._id,
      meetid,
      countryCode: userInfo?.countrycode || userInfo?.countryCode || "+91",
      userData: {
        age: userInfo?.age || 0,
        medicine: false,
        therapy: marketplaceTherapist?.designation || "Therapy",
        problem: primaryProblem,
      },
      ...overrides,
    };
  };

  const executeMarketplaceBooking = async (selectedPlan) => {
    const createOrderRequestData = await buildBookingRequestData(selectedPlan, {
      purpose: 0,
    });

    const createOrder = await bookSession(createOrderRequestData, userToken);
    const { status } = createOrder.data;

    if (status === "Booking Successful") {
      const bookingData = createOrder.data?.data || {};
      const withdrawalAmount = Math.abs(bookingData?.withdrawal?.transaction?.amount || 0);

      redirectAfterMarketplaceBooking({
        message: "Event Booked Successfully",
        bookingEvent: bookingData.bookingEvent,
        withdrawal: bookingData.withdrawal,
        balance: bookingData.balance,
        cashback: bookingData.cashback,
        orderId: bookingData.orderID,
        amountPaid: withdrawalAmount,
        planName: selectedPlan.planName,
        currency: "Wallet",
      });
      return;
    }

    const { goodLivesOrderID, orderId, customerEmail, customerName, currency, transactionAmount } = createOrder.data;

    const razorpayLoaded = await loadScript("https://checkout.razorpay.com/v1/checkout.js");
    if (!razorpayLoaded) {
      throw new Error("Unable to load payment gateway.");
    }

    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY,
      amount: transactionAmount,
      currency,
      name: "GoodLives",
      description: selectedPlan.planName,
      order_id: orderId,
      prefill: {
        name: customerName,
        email: customerEmail,
        contact: userInfo?.mobileNo || "",
      },
      notes: {
        goodLivesOrderID,
      },
      handler: async (response) => {
        try {
          dispatch(startLoading());
          const bookingRequestData = await buildBookingRequestData(selectedPlan, {
            meetid: createOrderRequestData.meetid,
            purpose: 1,
            goodLivesOrderID,
            paymentId: response.razorpay_payment_id,
            paymentOrderId: response.razorpay_order_id,
            paymentSignature: response.razorpay_signature,
          });

          const paymentSuccess = await bookSession(bookingRequestData, userToken);
          const bookingData = paymentSuccess.data?.data || {};
          dispatch(stopLoading());
          redirectAfterMarketplaceBooking({
            message: "Event Booked Successfully",
            bookingEvent: bookingData.bookingEvent,
            withdrawal: bookingData.withdrawal,
            balance: bookingData.balance,
            cashback: bookingData.cashback,
            orderId: goodLivesOrderID,
            amountPaid: transactionAmount,
            planName: selectedPlan.planName,
            currency,
          });
        } catch (err) {
          dispatch(stopLoading());
          if (err?.response?.data?.redirectToSignIn) {
            showError(err.response.data.error);
            setTimeout(
              () =>
                history.push({
                  pathname: "/signin",
                  state: { referer: location.pathname },
                }),
              3000,
            );
          } else {
            showError(err?.response?.data?.error || err.message || "Booking failed.");
          }
        }
      },
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.on("payment.failed", function () {
      setErrorpayment(true);
    });
    paymentObject.open();
  };

  const tryAutoBookWithWalletPlan = async (plansResponse, nextWalletBalance) => {
    if (!isMarketplaceBookingFlow || walletAutoBookingTriggered) {
      return false;
    }

    const deductFromWalletPlan = (plansResponse || []).find(
      (plan) => plan.planID === 1001 || plan.planName === "Deduct from Wallet",
    );

    if (!deductFromWalletPlan?.status || Number(nextWalletBalance || 0) <= 0) {
      return false;
    }

    setWalletAutoBookingTriggered(true);
    await executeMarketplaceBooking(deductFromWalletPlan);
    return true;
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 900);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const showError = (text) => {
    setError(text);
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      setOpen(false);
    }
    setOpen(false);
  };
  /*const [errorPayment, setErrorPayment] = useState(false)
  console.log(plans)*/
  const loadPlans = async () => {
    try {
      dispatch(startLoading());
      const res = await loadAllPaymentPlans(userToken, marketplaceTherapistId);
      const sortedPlans = res.data.plans?.sort((a, b) => b.sortOrder - a.sortOrder) || [];
      setPaymentPlans(sortedPlans);
      setWalletBalance(res.data.walletSessionBalance);
      const wasAutoBooked = await tryAutoBookWithWalletPlan(sortedPlans, res.data.walletSessionBalance);
      if (wasAutoBooked) {
        dispatch(stopLoading());
        return;
      }
      dispatch(stopLoading());
    } catch (error) {
      setWalletAutoBookingTriggered(false);
      dispatch(stopLoading());
      showError(error.toString());
    }
  };

  useEffect(() => {
    if (plans) {
      const sortedPlans = [...plans].sort((a, b) => b.sortOrder - a.sortOrder);

      setPaymentPlans(sortedPlans);
    } else if (!routeProps) {
      history.push("/dashboard/sessionBooking");
    }
    if (walletSessionBalance !== undefined && walletSessionBalance !== null) {
      setWalletBalance(walletSessionBalance);
    }
    if (currency) {
      setPaymentCurrency(currency);
    }
    if (categoryId) {
      setCategoryid(categoryId);
    }
    if (errorPayment) {
      setErrorpayment(errorPayment);
    }
    if (routeProps) {
      if (routeProps.currency) {
        setPaymentCurrency(routeProps.currency);
      }
      if (routeProps.categoryId) {
        setCategoryid(routeProps.categoryId);
      }
      if (routeProps.errorPayment) {
        setErrorpayment(routeProps.errorPayment);
      }
      loadPlans();
    }

    if (categoryId === 2 || categoryId === 3) {
      setSelectedSubscription("Deduct from Wallet");
    }
  }, []);

  useEffect(() => {
    if (!plans || !isMarketplaceBookingFlow || walletAutoBookingTriggered) {
      return;
    }

    const sortedPlans = [...plans].sort((a, b) => b.sortOrder - a.sortOrder);
    const deductFromWalletPlan = sortedPlans.find((plan) => plan.planID === 1001 || plan.planName === "Deduct from Wallet");

    if (!deductFromWalletPlan?.status || Number(walletBalance || 0) <= 0) {
      return;
    }

    const autoBook = async () => {
      try {
        dispatch(startLoading());
        setWalletAutoBookingTriggered(true);
        await executeMarketplaceBooking(deductFromWalletPlan);
        dispatch(stopLoading());
      } catch (err) {
        setWalletAutoBookingTriggered(false);
        dispatch(stopLoading());
        if (err?.response?.data?.redirectToSignIn) {
          showError(err.response.data.error);
          setTimeout(
            () =>
              history.push({
                pathname: "/signin",
                state: { referer: location.pathname },
              }),
            3000,
          );
        } else {
          showError(err?.response?.data?.error || err.message || "Booking failed.");
        }
      }
    };

    autoBook();
  }, [
    dispatch,
    executeMarketplaceBooking,
    history,
    isMarketplaceBookingFlow,
    location.pathname,
    plans,
    walletAutoBookingTriggered,
    walletBalance,
  ]);

  const bookEvent = async (p) => {
    try {
      dispatch(startLoading());
      if (typeof payAndBookEvent === "function") {
        await payAndBookEvent(p);
      } else if (isMarketplaceBookingFlow) {
        await executeMarketplaceBooking(p);
      } else {
        throw new Error("Payment flow is not available for this booking context.");
      }
      dispatch(stopLoading());
    } catch (err) {
      dispatch(stopLoading());
      if (err?.response?.data?.redirectToSignIn) {
        showError(err.response.data.error);
        setTimeout(
          () =>
            history.push({
              pathname: "/signin",
              state: { referer: location.pathname },
            }),
          3000,
        );
      } else {
        showError(err?.response?.data?.error || err.message || "Booking failed.");
      }
    }
  };

  return (
    <div>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="error" sx={{ width: "100%" }}>
          {error}
        </Alert>
      </Snackbar>
      {isMobile ? (
        <div className={`pp-mobileScreen-container ${isMarketplaceBookingFlow ? "pp-mobileScreen-container-marketplace" : ""}`}>
          <div className="pp-mobileScreen-header">
            <button
              onClick={() => (typeof setShowPayment === "function" ? setShowPayment(false) : history.goBack())}
              className="pp-mobileScreen-backButton"
            >
              <IoIosArrowBack size={13} style={{ marginTop: "-6px" }} />
            </button>
            {!isMarketplaceBookingFlow && <h3>Affordable Packages</h3>}
            <div className="pp-mobileScreen-backButton" style={{ backgroundColor: "#fffcf8" }} />
          </div>
          {isMarketplaceBookingFlow && (
            <div className="container-rcpp container-rcpp-marketplace">
              <h3>Affordable Packages</h3>
            </div>
          )}
          <div
            className={`pp-mobileScreen-progress-container ${isMarketplaceBookingFlow ? "pp-mobileScreen-progress-container-marketplace" : ""}`}
          >
            <div className="progress-line"></div>
            <div className="progress-fill" style={{ width: progressFillWidth }}></div>
            <div className="progress-steps">
              {Array.from({ length: progressStepCount }).map((_, index) => {
                const isCompleted = index < completedStepCount;
                const isActive = !isCompleted && index === completedStepCount;

                return (
                  <div
                    key={`mobile-progress-${index}`}
                    className={`pp-mobileScreen-progress-step ${isCompleted ? "completed" : ""} ${isActive ? "active" : ""}`}
                    style={isCompleted ? { color: "white", backgroundColor: "#49af7c", borderColor: "#49af7c" } : undefined}
                  >
                    {isCompleted ? "✔" : ""}
                  </div>
                );
              })}
            </div>
          </div>
          {paymentPlans && (
            <div className="pp-mobileScreen-left-cpp">
              {paymentPlans
                .filter((p) => (categoryid === 1 ? p.planID !== 1001 : categoryid === 2 ? p.planID === 1001 : true))
                .map((p) => {
                  let basePrice = p.basePrice;
                  let discountedPrice = p.discountedPrice;
                  let pricePerSession = p.pricePerSession;

                  if (paymentCurrency !== "INR") {
                    basePrice = p.basePriceUSD;
                    discountedPrice = p.discountedPriceUSD;
                    pricePerSession = p.pricePerSessionUSD;
                  }

                  return (
                    <>
                      <div
                        className={`pp-mobileScreen-container-lcpp ${p.planID === 1001 ? "walletPlan" : ""}  ${
                          p.planID === 1001 || selectedSubscription === p.planName ? "active" : ""
                        }`}
                        key={p.planID}
                        onClick={() => {
                          if (p.planID !== 1001) {
                            setSelectedSubscription(selectedSubscription === p.planName ? "" : p.planName);
                          }
                        }}
                      >
                        {p.planID !== 1001 && basePrice - discountedPrice !== 0 && selectedSubscription !== p.planName && (
                          <div className="pp-mobileScreen-tag-specialsubscription">
                            <p>
                              Save {basePrice - discountedPrice} {paymentCurrency}
                            </p>
                          </div>
                        )}

                        <p className="subscription-title" style={{ fontSize: "15px" }}>
                          {p.planName}
                          {p.planID !== 1001 && ( // Remove side arrow for planID 1001
                            <>
                              <div className="moresubscription" style={{ backgroundColor: "#E8FDF2", color: "black" }}>
                                <ExpandMoreIcon />
                              </div>
                              <div className="lesssubscription" style={{ backgroundColor: "#E8FDF2", color: "black" }}>
                                <ExpandLessIcon />
                              </div>
                            </>
                          )}
                        </p>

                        {/* If planID === 1001, show only the custom text */}
                        {p.planID === 1001 ? (
                          <>
                            <p className="wallet-session-text walletPlan" style={{ height: "200px" }}>
                              Schedule a therapy session from your wallet
                            </p>
                            <p></p>
                          </>
                        ) : (
                          <>
                            <p className="subscription-subtitle">This package includes:</p>
                            {selectedSubscription === p.planName && (
                              <ul className="subscription-subtitle">
                                {getPlanFeatures(p).map((f, index) => (
                                  <li key={index}>{f}</li>
                                ))}
                              </ul>
                            )}
                          </>
                        )}

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          {p.planID !== 1001 && (
                            <div className="price-details">
                              {selectedSubscription === p.planName && (
                                <>
                                  <div className="price-row" style={{ marginBottom: "5px" }}>
                                    {basePrice > discountedPrice && <p style={{ fontSize: "12px" }}>{basePrice}</p>}
                                    <p style={{ fontSize: "18px" }}>{discountedPrice}</p>
                                  </div>
                                  <p className="sessionName" style={{ fontSize: "12px" }}>
                                    {" "}
                                    for {p.planName.toLowerCase()}
                                  </p>
                                </>
                              )}
                              <p className="subscription-price" style={{ marginTop: "-20px", fontSize: 15 }}>
                                {pricePerSession} <span style={{ fontSize: 10 }}>{paymentCurrency} </span>
                                <span style={{ fontWeight: 500, fontSize: 16 }}> / Session</span>
                              </p>
                            </div>
                          )}
                          <div>
                            <img
                              src="https://ucarecdn.com/87474e1b-10c7-4381-9756-cd7dcaa1cee7/bookNowBtn.svg"
                              style={{ height: "80px", width: "210px", alignSelf: "center" }}
                              className={`subscription-price book-now-btn ${p.planID === 1001 ? "special" : "default"}`}
                              onClick={() => {
                                if (p.planID === 1001 && walletBalance < 1) {
                                  showError("No Balance Available in your Wallet. Please use other payment options.");
                                } else {
                                  bookEvent(p);
                                }
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })}
            </div>
          )}
        </div>
      ) : (
        <div className={`complete-payment-plan ${isMarketplaceBookingFlow ? "complete-payment-plan-marketplace" : ""}`}>
          {isMarketplaceBookingFlow ? (
            <>
              <div className="marketplace-payment-header">
                <div className="container-rcpp container-rcpp-marketplace" style={{ position: "relative" }}>
                  <h3>Affordable Packages</h3>
                  <button
                    onClick={() => (typeof setShowPayment === "function" ? setShowPayment(false) : history.goBack())}
                    className="backButton"
                  >
                    <IoIosArrowBack size={18} />
                  </button>
                </div>
                <div className="marketplace-progress">
                  <div className="marketplace-progress-line"></div>
                  <div className="marketplace-progress-fill" style={{ width: progressFillWidth }}></div>
                  <div className="marketplace-progress-steps">
                    {Array.from({ length: progressStepCount }).map((_, index) => {
                      const isCompleted = index < completedStepCount;
                      const isActive = !isCompleted && index === completedStepCount;

                      return (
                        <div
                          key={`desktop-progress-${index}`}
                          className={`marketplace-progress-step ${isCompleted ? "completed" : ""} ${isActive ? "active" : ""}`}
                        >
                          {isCompleted ? "✔" : ""}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="container-rcpp container-rcpp-default">
                <h3>Affordable Packages</h3>
                <button
                  onClick={() => (typeof setShowPayment === "function" ? setShowPayment(false) : history.goBack())}
                  className="backButton"
                >
                  <IoIosArrowBack size={18} />
                </button>
              </div>
              <div className="progress-container progress-container-default">
                <div className="progress-line"></div>
                <div className="progress-fill" style={{ width: progressFillWidth }}></div>
                <div className="progress-steps">
                  {Array.from({ length: progressStepCount }).map((_, index) => {
                    const isCompleted = index < completedStepCount;
                    const isActive = !isCompleted && index === completedStepCount;

                    return (
                      <div
                        key={`desktop-progress-${index}`}
                        className={`progress-step ${isCompleted ? "completed" : ""} ${isActive ? "active" : ""}`}
                      >
                        {isCompleted ? "✔" : ""}
                      </div>
                    );
                  })}
                </div>
              </div>
            </>
          )}

          {paymentPlans && (
            <div className="left-cpp">
              {paymentPlans
                .filter((p) => (categoryid === 1 ? p.planID !== 1001 : categoryid === 2 ? p.planID === 1001 : true))
                .map((p) => {
                  let basePrice = p.basePrice;
                  let discountedPrice = p.discountedPrice;
                  let pricePerSession = p.pricePerSession;

                  if (paymentCurrency !== "INR") {
                    basePrice = p.basePriceUSD;
                    discountedPrice = p.discountedPriceUSD;
                    pricePerSession = p.pricePerSessionUSD;
                  }

                  return (
                    <>
                      <div
                        className={`container-lcpp ${p.planID === 1001 ? "walletPlan" : ""} ${p.planID === 1001 || selectedSubscription === p.planName ? "active" : ""}`}
                        key={p.planID}
                        onClick={() => {
                          if (p.planID !== 1001) {
                            setSelectedSubscription(selectedSubscription === p.planName ? "" : p.planName);
                          }
                        }}
                      >
                        {p.planID !== 1001 && basePrice - discountedPrice !== 0 && selectedSubscription !== p.planName && (
                          <div className="tag-specialsubscription">
                            <p>
                              Save {basePrice - discountedPrice} {paymentCurrency}
                            </p>
                          </div>
                        )}

                        <p className="subscription-title">
                          {p.planName}
                          {p.planID !== 1001 && ( // Remove side arrow for planID 1001
                            <>
                              <div className="moresubscription" style={{ backgroundColor: "#E8FDF2", color: "black" }}>
                                <ExpandMoreIcon />
                              </div>
                              <div className="lesssubscription" style={{ backgroundColor: "#E8FDF2", color: "black" }}>
                                <ExpandLessIcon />
                              </div>
                            </>
                          )}
                        </p>

                        {/* If planID === 1001, show only the custom text */}
                        {p.planID === 1001 ? (
                          <>
                            <p className="wallet-session-text walletPlan" style={{ height: "200px" }}>
                              Schedule a therapy session from your wallet
                            </p>
                            <p></p>
                          </>
                        ) : (
                          <>
                            <p className="subscription-subtitle">This package includes:</p>
                            {selectedSubscription === p.planName && (
                              <ul className="subscription-subtitle">
                                {getPlanFeatures(p).map((f, index) => (
                                  <li key={index}>{f}</li>
                                ))}
                              </ul>
                            )}
                          </>
                        )}

                        <div className="book-now-container-cont">
                          {p.planID !== 1001 && (
                            <div className="price-details">
                              {selectedSubscription === p.planName && (
                                <>
                                  <div className="price-row">
                                    {basePrice > discountedPrice && <p>{basePrice}</p>}
                                    <p>{discountedPrice}</p>
                                  </div>
                                  <p className="sessionName"> for {p.planName.toLowerCase()}</p>
                                </>
                              )}
                              <p className="subscription-price" style={{ marginTop: "-20px" }}>
                                {pricePerSession} <span style={{ fontSize: 13 }}>{paymentCurrency} </span>
                                <span style={{ fontWeight: 500 }}> / Session</span>
                              </p>
                            </div>
                          )}

                          {/* <p
                          className="subscription-price"
                          style={{ fontWeight: 600, cursor: "pointer" }}
                          onClick={() => {
                            if (p.planID === 1001 && walletBalance < 1) {
                              showError(
                                "No Balance Available in your Wallet. Please use other payment options."
                              );
                            } else {
                              bookEvent(p);
                            }
                          }}
                        >
                          <span className="book-txt">Book Now</span>
                        </p> */}
                          <div className="book-now-container">
                            <img
                              src={BookNowButton}
                              className={`subscription-price book-now-btn ${p.planID === 1001 ? "special" : "default"}`}
                              onClick={() => {
                                if (p.planID === 1001 && walletBalance < 1) {
                                  showError("No Balance Available in your Wallet. Please use other payment options.");
                                } else {
                                  bookEvent(p);
                                }
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })}
            </div>
          )}
        </div>
      )}
      {errorpayment && (
        <div
          className="popup-payment-alert-overaly"
          onClick={() => {
            /*this.setState({ errorPayment: false }) }*/ setErrorpayment(false);
          }}
        ></div>
      )}
      <div
        className="popup-payment-alert"
        style={{
          opacity: errorpayment ? 1 : 0,
          pointerEvents: errorpayment ? "all" : "none",
        }}
      >
        <div className="left-ppa">
          <p className="title-ilppa">Oops!</p>
          <p className="desc-ilppa">
            Sorry, the Payment couldn't go through. Please retry to complete the payment. If the money is debited from your
            account, it will be credited back in 5-7 business days.
          </p>
          <img src="https://ucarecdn.com/149066e3-2139-4d8c-985b-6908c7a2e08b/paymentFailIcon.svg" alt="warning" />
          <div className="retrybtn">
            <button
              onClick={() => {
                setErrorpayment(false);
              }}
            >
              Retry Payment
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PaymentPlan;
